// class that provide basic information and facilities for current application :
// front-end/back-end versions, application name, logs, etc.

import {Injectable} from "@angular/core";
import {IAppInfoService} from "libComm";

import exportFromJSON from "export-from-json";
import {GeneralService} from "../../services/crud/general.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

const APP_NAME: string = "EUR"; // short application name
const FE_VERS: string = "1.2.0lc";  // front-end version
//const BE_VERS: string = "0.3.5be" // it comes from back-end

@Injectable({
	providedIn: 'root'
})
export class EURAppInfoService implements IAppInfoService
{
	appShortName: string;
	feVersion: string;  // front-end version (e.g. x.y.z)
	appName: string;  // application name
	beVersion: string;
	beVersionLong: string;

	constructor(private ddtgs: GeneralService)
	{
		this.appShortName = APP_NAME;
		this.appName = APP_NAME + " Application";

		this.feVersion = `Web application version: ` + FE_VERS;
		this.beVersion = "???";
		this.beVersionLong = `Server application version: `;

		this.initStorage();
	}

	// initialize application storage : local, sessions, etc.
	initStorage(): void
	{
		// initialize 'sessionStorage' with something
		// sessionStorage.setItem('httpLog', JSON.stringify({name: 'Dummy User', age: 99}));
	}

	getAppVersion(): string
	{
		return this.feVersion;
	}

	getAppShortName(): string
	{
		return this.appShortName;
	}

	getAppName(): string
	{
		return this.appName;
	}

	getBackendVersionObs(): Observable<string>
	{
		return this.ddtgs.getVersion().pipe(
			map( value => {

				this.beVersion= value['oContent'];

				return this.beVersionLong + this.beVersion;
			})
		);
	}

	// provide downloadable application's logs
	provideLogs(): void
	{
		// console.log("provide application logs");

		const data = JSON.parse(sessionStorage.getItem('httpLog') ?? '');
		const fileName = 'download_' + Date.now();
		const exportType = exportFromJSON.types.json;

		// open a download dialog for saving logs as .json file
		exportFromJSON({data, fileName, exportType});
	}
}